export const STATUS_LABEL = {
  incomplete: 'Незавершён',
  awaiting_interview: 'Ждёт интервью',
  no_show: 'Не явка',
  active: 'Активна',
  hidden_auto: 'Скрыта авто',
  hidden_manual: 'Скрыта лично',
  blocked: 'Заблокирована',
  deleted: 'Удалена',
};

export const STATUS_DESCRIPTION = {
  incomplete: 'Анкета создана, но пользователь ещё не закончил заполнение.',
  awaiting_interview: 'Пользователь записался на собеседование с куратором, оно ещё не проведено.',
  no_show: 'Пользователь не пришёл на забронированное собеседование.',
  active: 'Анкета проверена куратором и видна другим пользователям в системе.',
  hidden_auto: 'Анкета скрыта автоматически — у пользователя закончились искры.',
  hidden_manual: 'Пользователь сам временно скрыл анкету.',
  blocked: 'Анкета заблокирована куратором или админом.',
  deleted: 'Пользователь сам удалил аккаунт — личные данные обезличены, номер телефона свободен для новой регистрации.',
};

export const STATUS_TOOLTIP = Object.entries(STATUS_LABEL)
  .map(([key, label]) => `${label} — ${STATUS_DESCRIPTION[key]}`)
  .join('\n');
